import React, { useState, useEffect } from "react";
export default function CompanyProfile() {
  const [data, setData] = useState({});
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState({ name: "Digital Smart Technology", email: "", phone: "", address: "Jaipur, Rajasthan", state_code: "08", gstin: "", pan: "", bank_name: "", acc_no: "", ifsc: "" });

  const loadData = () => fetch('/api/company').then(r=>r.json()).then(d=>{ setData(d||{}); setForm(d.name ? d : form); });
  useEffect(() => { loadData(); }, []);

  const save = async (e) => {
    e.preventDefault();
    await fetch('/api/company', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(form) });
    setEdit(false); loadData();
  };

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <div className="flex justify-between mb-4"><h1 className="text-2xl font-bold">Company / GST Profile</h1><button onClick={()=>setEdit(!edit)} className="bg-gray-800 text-white px-4 py-2 rounded">{edit ? "Cancel" : "Edit Profile"}</button></div>
      <div className="bg-white shadow p-6 rounded">
        {edit ? (
          <form onSubmit={save} className="grid grid-cols-2 gap-4">
            <div><label className="block text-sm">Company Name</label><input required className="w-full border p-2 rounded" value={form.name} onChange={e=>setForm({...form, name:e.target.value})} /></div>
            <div><label className="block text-sm">GSTIN</label><input className="w-full border p-2 rounded" value={form.gstin} onChange={e=>setForm({...form, gstin:e.target.value})} /></div>
            <div><label className="block text-sm">PAN</label><input className="w-full border p-2 rounded" value={form.pan} onChange={e=>setForm({...form, pan:e.target.value})} /></div>
            <div><label className="block text-sm">State Code (e.g. 08)</label><input className="w-full border p-2 rounded" value={form.state_code} onChange={e=>setForm({...form, state_code:e.target.value})} /></div>
            <div><label className="block text-sm">Bank Name</label><input className="w-full border p-2 rounded" value={form.bank_name} onChange={e=>setForm({...form, bank_name:e.target.value})} /></div>
            <div><label className="block text-sm">A/c No</label><input className="w-full border p-2 rounded" value={form.acc_no} onChange={e=>setForm({...form, acc_no:e.target.value})} /></div>
            <div><label className="block text-sm">IFSC Code</label><input className="w-full border p-2 rounded" value={form.ifsc} onChange={e=>setForm({...form, ifsc:e.target.value})} /></div>
            <div className="col-span-2"><button className="bg-blue-600 text-white px-6 py-2 rounded w-full">Save Profile</button></div>
          </form>
        ) : (
          <div className="grid grid-cols-2 gap-4 text-lg">
            <p><strong>{data.name}</strong></p><p>GSTIN: {data.gstin || "N/A"}</p><p>PAN: {data.pan || "N/A"}</p><p>State Code: {data.state_code}</p>
            <p>Bank: {data.bank_name} (A/c: {data.acc_no})</p>
          </div>
        )}
      </div>
    </div>
  );
}
